export default "__VITE_ASSET__rcPsL7Aw__"